import(/* webpackMode: "eager", webpackExports: ["BannerSlider"] */ "/app/apps/web/src/app/(app)/(landing)/banner-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/app/apps/web/src/app/(app)/(landing)/banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cover"] */ "/app/apps/web/src/app/(app)/(landing)/cover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectionList"] */ "/app/apps/web/src/app/(app)/(landing)/selection-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Sidebar/ui/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Sidebar/ui/SidebarTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/widgets/VideoHls/ui/VideoHls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.25_@babel+core@7.27.4_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1/node_modules/next/dist/client/app-dir/link.js");
